import { useState } from "react";
import { AlertTriangle, Flag } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function ReportDialog({ open, onOpenChange, targetId, username, conversationId = null }) {
  const { site } = useAuth();
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (reason.trim().length < 3) return;
    setLoading(true);
    try {
      await api.post("/reports", { reported_user_id: targetId, reason, conversation_id: conversationId });
      toast.success("Bildirimin admin paneline iletildi.");
      setReason("");
      onOpenChange(false);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-950/95 backdrop-blur-xl border-slate-800 text-slate-100 sm:max-w-md" data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Flag className="h-4 w-4 text-red-400" /> Kullanıcıyı Bildir: {username}</DialogTitle>
          <DialogDescription className="text-slate-400">Bildirim sebebini açık şekilde yaz. Admin inceleyecek.</DialogDescription>
        </DialogHeader>
        <div data-testid="report-warning" className="rounded-xl border-2 border-red-500 bg-red-950/80 p-4 text-red-100 text-sm font-semibold flex gap-3">
          <AlertTriangle className="h-5 w-5 shrink-0 text-red-300" />
          <span>{site?.report_warning || "Asılsız ihbar verirseniz SİZ banlanırsınız."}</span>
        </div>
        <Textarea data-testid="report-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Bildirim sebebi..." className="cx-input min-h-[110px] h-auto" />
        <Button data-testid="report-submit-button" onClick={submit} disabled={loading || reason.trim().length < 3} className="h-11 rounded-xl bg-red-600 hover:bg-red-500 text-white font-bold">
          {loading ? "Gönderiliyor..." : "Bildir"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
